const contacts = [
  { icon: 'ri-mail-line', label: '反馈邮箱', value: 'feedback@example-demo.com', note: '仅作演示，非真实邮箱' },
  { icon: 'ri-message-3-line', label: '内容纠错', value: 'correction@example-demo.com', note: '条目信息与分类建议' },
  { icon: 'ri-time-line', label: '响应时间', value: '工作日 10:00 – 18:00', note: '演示站点，暂不提供实时客服' },
  { icon: 'ri-map-pin-line', label: '站点性质', value: '线上内容演示站点', note: '无实体门店与线下服务' },
];

export default function AboutContact() {
  return (
    <section aria-label="联系方式" className="w-full px-4 md:px-8 pt-14 md:pt-16">
      <div className="rounded-lg border border-background-200 bg-background-50 p-6 md:p-8">
        <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-3">
          <div>
            <h2 className="text-xl md:text-2xl font-bold text-foreground-950 flex items-center gap-2">
              <span className="w-1 h-5 rounded-full bg-accent-500" />
              联系我们
            </h2>
            <p className="mt-2 text-sm text-foreground-500">内容合作、问题反馈与使用建议，都可以通过这些渠道沟通。</p>
          </div>
          <span className="text-[11px] text-foreground-400">以下信息为演示占位，不代表真实联系方式</span>
        </div>

        <div className="mt-6 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-3">
          {contacts.map((item) => (
            <div key={item.label} className="rounded-lg bg-background-100 border border-background-200 p-4">
              <span className="w-9 h-9 rounded-md bg-secondary-100 text-secondary-700 flex items-center justify-center">
                <i className={`${item.icon} text-base`} />
              </span>
              <p className="mt-3 text-[11px] text-foreground-400">{item.label}</p>
              <p className="mt-1 text-sm font-medium text-foreground-950 break-all">{item.value}</p>
              <p className="mt-2 text-[11px] text-foreground-500">{item.note}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}